import ArticleLayout from '@/components/feature/ArticleLayout';

const pageData = {
  title: 'Luxury Brands on AllChinaBuy Spreadsheet: Complete List',
  description: 'Access premium luxury brands through our AllChinaBuy Spreadsheet. From Gucci to Balenciaga, find authentic-quality products at accessible prices from verified sellers.',
  image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20luxury%20fashion%20accessories%20including%20designer%20handbag%20silk%20scarf%20and%20gold%20jewelry%20on%20cream%20white%20marble%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20high-end%20style%2C%20warm%20neutral%20tones&width=1200&height=600&seq=art-luxury-brands-2026&orientation=landscape',
  imageAlt: 'Luxury Brands on AllChinaBuy Spreadsheet',
  category: 'Luxury',
  readTime: '9 min read',
  dateLabel: 'Updated June 2026',
  schemaData: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: 'Luxury Brands on AllChinaBuy Spreadsheet 2026',
    description: 'Access luxury brands through verified AllChinaBuy Spreadsheet. Gucci to Balenciaga at accessible prices.',
    datePublished: '2026-06-18',
    dateModified: '2026-06-25',
    author: { '@type': 'Organization', name: 'AllChinaBuySpreadsheet.ink' },
    publisher: { '@type': 'Organization', name: 'AllChinaBuySpreadsheet.ink' },
  },
};

export default function LuxuryBrandsPage() {
  return (
    <ArticleLayout {...pageData}>
      <section>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-10 mb-4">
          Luxury Shopping with AllChinaBuy Spreadsheet
        </h2>
        <p className="text-foreground-700 leading-relaxed">
          The <strong>AllChinaBuy Spreadsheet</strong> opens the door to premium luxury brands through verified sellers who consistently deliver exceptional quality. Our curated links span the most sought-after luxury houses including Gucci, Balenciaga, Louis Vuitton, Prada, Dior, and many more. Each seller has been thoroughly vetted to ensure their products meet the high standards luxury shoppers expect.
        </p>
        <p className="text-foreground-700 leading-relaxed mt-3">
          What makes our AllChinaBuy Spreadsheet particularly valuable for luxury shoppers is the combination of verified quality and accessible pricing. By connecting directly with trusted sellers, you avoid the markup that traditional retail adds while still receiving products that meet premium quality standards.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-10 mb-4">
          Categories for Luxury Items
        </h2>
        <p className="text-foreground-700 leading-relaxed">
          Our AllChinaBuy Spreadsheet features luxury items across multiple categories. The Bags category includes designer handbags, backpacks, and totes from top luxury houses. The Accessories section covers belts, wallets, sunglasses, and jewelry from premium brands. The Perfumes category features authentic designer fragrances from houses like Tom Ford, Creed, and Jo Malone.
        </p>
        <p className="text-foreground-700 leading-relaxed mt-3">
          For clothing, our Jackets, Hoodies, and T-Shirts categories all include luxury designer pieces from verified sellers. Whether you are looking for a statement Balenciaga hoodie or a classic Gucci belt, our AllChinaBuy Spreadsheet connects you with sellers who specialize in these premium categories.
        </p>
      </section>
    </ArticleLayout>
  );
}